const state = {
  forms: null,
  formsFields: [],
  activeForm: null
};

export default state;
